import { Box, Stack, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

// Same PDFs as the scholarship forms — downloadable helpers for students
const INSTRUCTIONS_PDF_URL =
  "https://firebasestorage.googleapis.com/v0/b/al-kauser-b6277.firebasestorage.app/o/products%2FInstructions%20to%20upload%20documents%20on%20the%20Portal.pdf%2Btyweyey%2B1773097686967-999457?alt=media&token=17afd8de-84a4-4616-bf5d-cc8f23c749f6";
const REFERENCE_LETTER_PDF_URL =
  "https://firebasestorage.googleapis.com/v0/b/al-kauser-b6277.firebasestorage.app/o/products%2FTemplate%20Reference%20Letter%20for%20Scholarship.pdf%2Btyweyey%2B1774389937719-134219?alt=media&token=3315f7f0-90a3-4727-9a03-9f4250ec9172";

const DOWNLOADABLE_DOCS = [
  { label: "Template Reference Letter (PDF)", url: REFERENCE_LETTER_PDF_URL },
  { label: "Upload Document Guidelines (PDF)", url: INSTRUCTIONS_PDF_URL },
];

const HelpfulDownloads = ({ sx = {} }) => (
  <Box
    sx={{
      mb: 3,
      p: 2,
      border: "1px solid #208146",
      borderRadius: 2,
      bgcolor: "#f0f8f4",
      ...sx,
    }}
  >
    <Typography variant="h6" sx={{ color: "#208146", fontWeight: "bold", mb: 1 }}>
      Helpful Downloads
    </Typography>
    <Stack direction={{ xs: "column", sm: "row" }} gap={2}>
      {DOWNLOADABLE_DOCS.map(({ label, url }) => (
        <Stack
          key={label}
          direction="row"
          alignItems="center"
          onClick={() => window.open(url, "_blank", "noopener,noreferrer")}
          sx={{
            border: "2px solid #208146",
            borderRadius: "11px",
            bgcolor: "white",
            p: 1,
            pr: 2,
            cursor: "pointer",
            "&:hover": { bgcolor: "#dff0d8" },
          }}
        >
          <DownloadIcon sx={{ color: "#208146", mr: 1 }} />
          <Typography sx={{ color: "#208146", fontWeight: 500 }}>{label}</Typography>
        </Stack>
      ))}
    </Stack>
  </Box>
);

export default HelpfulDownloads;
